
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';

import CommonTitle from './components/commonTitle.vue';
import ProductNoticeList from './components/productNoticeList.vue';

@Component({
  components: { CommonTitle, ProductNoticeList }
})
export default class ProductNotice extends Vue {

  @Getter noticeList: { [key: string]: any };

  @Action getNoticeList: (params: object) => void;

  created() {
    // 获取公告列表
    const params = {
      TypeID: '',
      keyword: '',
      SortList: [ {
        SortField: 'ModifyOn', // ModifyOn ViewCount
        SortMode: 'DESC'
      }],
      PageIndex: 1,
      PageSize: 5
    };
    this.getNoticeList(params);
  }
}
